import { createFileRoute } from '@tanstack/react-router'

import { feedbackResultsSearchSchema } from '@/pages/feedback-forms/results/results-search'

// A read-only page: the section's view permission is the whole guard, so staff
// who cannot open the builder still read the results.
export const Route = createFileRoute('/_layout/feedback-forms/$formId/results')({
  validateSearch: feedbackResultsSearchSchema,
})
